import React, { useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import AuthPanel from '../../components/auth/AuthPanel'

const LoginPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { user, loading: authLoading, signInWithGoogle, signInWithEmail, signUpWithEmail } = useAuth()
  const [isSignUp, setIsSignUp] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const redirectPath = useMemo(() => {
    const from = location.state?.from
    if (!from?.pathname) return '/oracle'
    return `${from.pathname || ''}${from.search || ''}${from.hash || ''}`
  }, [location.state])

  useEffect(() => {
    if (authLoading || !user) return
    navigate(redirectPath, { replace: true })
  }, [authLoading, navigate, redirectPath, user])

  const handleGoogleSignIn = async () => {
    try {
      setLoading(true)
      setError('')
      await signInWithGoogle()
      navigate(redirectPath, { replace: true })
    } catch (error) {
      setError('Falha ao entrar com Google: ' + error.message)
    } finally {
      setLoading(false)
    }
  }

  const handleEmailAuth = async (e) => {
    e.preventDefault()
    try {
      setLoading(true)
      setError('')
      
      if (isSignUp) {
        await signUpWithEmail(email, password)
      } else {
        await signInWithEmail(email, password)
      }
      navigate(redirectPath, { replace: true })
    } catch (error) {
      setError(`${isSignUp ? 'Registo' : 'Login'} falhou: ` + error.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="filterbet-auth-page">
      <div className="w-100 d-flex justify-content-center">
        <AuthPanel
          email={email}
          password={password}
          error={error}
          isSignUp={isSignUp}
          loading={loading || authLoading}
          onEmailChange={setEmail}
          onGoogleSignIn={handleGoogleSignIn}
          onPasswordChange={setPassword}
          onSubmit={handleEmailAuth}
          onToggleMode={() => setIsSignUp((current) => !current)}
        />
      </div>
    </div>
  )
}

export default LoginPage
